import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AllowListAuthStore } from './allow-list-auth.store';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {

    constructor(
        private router: Router,
        private allowListStore: AllowListAuthStore
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const routePath = state.url;
        return this.checkAccess(routePath);
    }

    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        const routePath = segments.map(segment => segment.path).join('/');
        return this.checkAccess(routePath);
    }

    private checkAccess(routePath: string): boolean {
        if (!this.allowListStore.isLoaded()) {
            // Config not yet loaded — allow navigation (dashboard / login flow)
            return true;
        }

        // Always allow dashboard / root paths
        if (routePath === '/' || routePath === '' || routePath === '/home' || routePath === '/newReferral') {
            return true;
        }

        if (this.allowListStore.isRouteAllowed(routePath)) {
            return true;
        }

        this.router.navigate(['/']);
        return false;
    }
}
